<template>
    <div class="ls-box">
        <el-dropdown>
            <a class="el-icon-menu"></a>
            <el-dropdown-menu slot="dropdown">
                <div class="p-20 box">
                    <div
                        v-for="(item, index) in temp"
                        :key="index"
                        :class="{ on: item.is_des }"
                        @click="
                            () => {
                                temp[index].is_des = item.is_des == 0 ? 1 : 0;
                            }
                        "
                        class="item"
                        v-if="item.is_show">
                        {{ item.COLUMN_COMMENT }}
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            temp: []
        };
    },
    watch: {
        value(val) {
            this.temp = val;
        }
    },
    created() {},
    methods: {}
};
</script>
<style lang="scss" scoped>
@import 'index.scss';
</style>